import axios from 'axios';
const ROOT = typeof window !== 'undefined' && window.app_url ? window.app_url('') : '/';
const MTUNIU_ROOT = typeof window !== 'undefined' && window.app_url ? window.app_url('', 'mtuniu') : '/';
const GET_BASE_INFO_URL = ROOT + 'api/item/getProductDetailForWap';
const GET_DERIVATIVE_PACKAGE_LIST_URL = ROOT + 'api/item/derivativePkg';
const GET_COMMENT_URL = ROOT + 'api/item/comment';
const GET_CUSTOMER_ADDRESS_URL = ROOT + 'api/item/getCustomerAddress';
const ADD_CUSTOMER_ADDRESS_URL = ROOT + 'api/item/addOrUpdateAddressInfo';
const GET_AREA_LIST = MTUNIU_ROOT + 'api/selective/index/getPlaceList';
const GET_TOKEN = ROOT + 'api/item/bookBaseInfo';
const CREATE_ORDER = ROOT + 'api/item/createOrder';
const GET_PAY = ROOT + 'api/item/cashier';
const SEND_CHECK_CODE = ROOT + 'api/item/sendCheckCode';
const CHECK_SMS_CODE = ROOT + 'api/item/checkSmsCode';
const GET_PRODUCT_ACTIVITY = ROOT + 'api/item/prdFindAct';
const GET_ORDER_ACTIVITY = ROOT + 'api/item/orderFindAct';
const RECEIVE_COUPONS = ROOT + 'api/item/receiveCoupons';
const ADD_FAVORITE_URL = ROOT + 'api/item/addFavorite';
const DELETE_FAVORITE_URL = ROOT + 'api/item/deleteFavorite';
const GET_USER_LOGIN_URL = ROOT + 'api/index/user';
const GET_PACKAGE_LIST_URL = ROOT + 'api/item/pkg';
const GET_JOURNEY_URL = ROOT + 'api/item/journey';
const GET_INVOICE_RULE_URL = ROOT + 'api/order/queryInvoiceRule';
const GET_PLANE_INFO_URL = ROOT + 'api/item/queryPlaneInfo';
const CREATE_BARGAIN_ORDER = ROOT + 'api/item/createBargainOrder';
const GET_QR_CODE = ROOT + 'api/item/getQrCode';
const GET_BOOKING_ATTR_URL = ROOT + 'api/item/getBookingAttribute';
const ADD_COUPON = ROOT + 'api/item/addCoupon';
const GET_ORDER_DETAIL_URL = ROOT + 'api/item/orderDetail';
const GET_GROUP_DYNAMICS = ROOT + 'api/item/getGroupDynamics';
const GET_PENDING_GROUP_LIST = ROOT + 'api/item/getPendingGroupList';
const AREA_CHECK_URL = ROOT + 'api/item/areaCheck';
const QUERY_CUSTOMER_IDENTITY_LIST_URL = ROOT + 'api/item/queryCustomerIdentityList';
const CITY_URL = ROOT + 'api/item/city';
const EXCHANGE_URL = ROOT + 'api/item/exchange';
const GET_JOURNEY_FOUR_URL = ROOT + 'api/item/journeyFour';
const BOOK_CHECK_URL = ROOT + 'api/item/bookCheck';
const GET_COV_INFO = ROOT + 'api/item/getCovInfo';
const GET_EXCHANGE_RATIO = ROOT + 'api/item/getExchangeRatio';
const GET_TOTAL_CREDITS = ROOT + 'api/item/getTotalCredits';

// 封装常用的get请求
function getApiPromise(url, params, fallBack) {
    return new Promise(function (resolve, reject) {
        axios.get(url, params ? {params} : {}).then(response => {
            if (response.data && response.data.data) {
                resolve(response.data.data);
            } else {
                resolve(fallBack === undefined ? fallBack : {});
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    })
}

/**
 * 获取线路基本信息
 * @public
 * @param object
 * @return {Promise}
 */
export function getBaseInfoP(params) {
    return getApiPromise(GET_BASE_INFO_URL, params)
}

/**
 * 获取衍生品套餐信息
 * @public
 * @param object
 * @return {Promise}
 */
export function getDerivativePackageListP(params) {
    return getApiPromise(GET_DERIVATIVE_PACKAGE_LIST_URL, params)
}

/**
 * 获取套餐信息
 * @public
 * @param object
 * @return {Promise}
 */
export function getPackageListP(params) {
    return getApiPromise(GET_PACKAGE_LIST_URL, params)
}

/**
 * 获取行程
 * @public
 * @param object
 * @return {Promise}
 */
export function getJourneyP(params) {
    return getApiPromise(GET_JOURNEY_URL, params)
}

/**
 * 获取点评信息
 * @public
 * @param object
 * @return {Promise}
 */
export function getCommentP(params) {
    return getApiPromise(GET_COMMENT_URL, params)
}

/**
 * 获取常用地址信息
 * @public
 * @param object
 * @return {Promise}
 */
export function getCustomerAddressP(params) {
    return getApiPromise(GET_CUSTOMER_ADDRESS_URL, params)
}

/**
 * 编辑地址信息
 * @public
 * @param object
 * @return {Promise}
 */
export function addCustomerAddressP(params) {
    if (params.addressId === 0) {
        delete params.addressId;
    }
    return new Promise(function (resolve, reject) {
        axios.post(ADD_CUSTOMER_ADDRESS_URL, params).then(response => {
            if (response.data) {
                if (response.data && response.data.data) {
                    resolve(response.data.data);
                } else {
                    resolve('');
                }
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 获取省市信息
 * @public
 * @return {Promise}
 */
export function getAreaListP() {
    return getApiPromise(GET_AREA_LIST)
}

/**
 * 获取疫情提醒信息
 * @public
 * @return {Promise}
 */
 export function getCoronaviruP(params) {
    return getApiPromise(GET_COV_INFO, params);
}

/**
 * 获取积分信息
 * @public
 * @return {Promise}
 */
export function getTotalCreditsP(params) {
    return getApiPromise(GET_TOTAL_CREDITS, params);
}

/**
 * 获取积分兑换比例
 * @public
 * @return {Promise}
 */
export function getExchangeRatioP(params) {
    return getApiPromise(GET_EXCHANGE_RATIO, params);
}
/**
 * 获取订单token
 * @public
 * @return {Promise}
 */
export function getTokenP(params) {
    return new Promise(function (resolve, reject) {
        axios.get(GET_TOKEN, { params }).then(response => {
            if (response.data && response.data.data) {
                resolve(response.data.data);
            } else {
                reject(response.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

/**
 * 提交订单
 * @public
 * @return {Promise}
 */
export function createOrderP(params) {
    return new Promise(function (resolve, reject) {
        axios.post(CREATE_ORDER, {
            data: JSON.stringify(params)
        }).then(response => {
            if (response.data) {
                if (response.data && response.data.data) {
                    resolve(response.data);
                } else {
                    resolve({});
                }
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 提交订单
 * @public
 * @return {Promise}
 */
export function getPayP(params) {
    return new Promise(function (resolve, reject) {
        axios.get(GET_PAY, { params }).then(response => {
            let body = response.data || {};

            if (body.success && body.data && body.data.payFlag === 1 && body.data.url) {
                resolve(body.data);
            } else {
                resolve({});
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 发送短信
 * @public
 * @return {Promise}
 */
export function sendCheckCodeP(params) {
    return new Promise(function (resolve, reject) {
        axios.post(SEND_CHECK_CODE, params).then(response => {
            resolve(response && response.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 短信验证码校验
 * @public
 * @return {Promise}
 */
export function checkSmsCodeP(params) {
    return new Promise(function (resolve, reject) {
        axios.post(CHECK_SMS_CODE, params).then(response => {
            resolve(response && response.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 获取产品活动
 * @public
 * @return {Promise}
 */
export function getProductActivityP(params) {
    return getApiPromise(GET_PRODUCT_ACTIVITY, params, '')
}

/**
 * 获取订单活动
 * @public
 * @return {Promise}
 */
export function getOrderActivityP(params) {
    return getApiPromise(GET_ORDER_ACTIVITY, params, '')
}

/**
 * 领取优惠券
 * @public
 * @return {Promise}
 */
export function receiveCouponsP(params) {
    return new Promise(function (resolve, reject) {
        axios.post(RECEIVE_COUPONS, params).then(response => {
            if (response.data) {
                resolve(response.data);
            } else {
                resolve({});
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 加入收藏
 * @public
 * @param object
 * @return {Promise}
 */
export function addFavoriteP(params) {
    return new Promise(function (resolve, reject) {
        axios.post(ADD_FAVORITE_URL, params).then(response => {
            if (response && response.data) {
                resolve(response.data);
            } else {
                resolve({});
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 删除收藏
 * @public
 * @param object
 * @return {Promise}
 */
export function deleteFavoriteP(params) {
    return new Promise(function (resolve, reject) {
        axios.post(DELETE_FAVORITE_URL, params).then(response => {
            if (response && response.data) {
                resolve(response.data);
            } else {
                resolve({});
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 判断是否登陆
 * @public
 * @return {Promise}
 */
export function getUserInfoP() {
    return new Promise(function (resolve, reject) {
        axios.get(GET_USER_LOGIN_URL).then(response => {
            if (response && response.data && response.data.data) {
                resolve(response.data.data);
            } else {
                resolve({
                    isLogin: false
                });
            }
        })
            .catch(err => {
                console.log(err);
                reject({
                    message: err,
                    isLogin: false
                });
            });
    });
}

/**
 * 查询发票规则
 * @public
 * @return {Promise}
 */
export function queryInvoiceRuleP() {
    return getApiPromise(GET_INVOICE_RULE_URL)
}

export function queryPlaneInfoP(params) {
    return getApiPromise(GET_PLANE_INFO_URL, params)
}
export const GET_CUSTOM_ATTR_SELECTION_URL = ROOT + 'api/item/getPrdCustomAttrSelectionList';

/**
 * 查询预定属性
 * @public
 * @return {Promise}
 */

export function getBookingAttributeP(params) {
    return new Promise(function (resolve, reject) {
        axios.get(GET_BOOKING_ATTR_URL, { params }).then(response => {
            if (response.data) {
                if (response.data && response.data.data) {
                    resolve(response.data.data);
                } else {
                    resolve({});
                }
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 生成砍价订单
 * @public
 * @return {Promise}
 */
export function createBargainOrderP(params) {
    return new Promise(function (resolve, reject) {
        axios.post(CREATE_BARGAIN_ORDER, params).then(response => {
            if (response.data) {
                if (response.data && response.data.data) {
                    resolve(response.data);
                } else {
                    resolve({});
                }
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 生成小程序码
 * @public
 * @return {Promise}
 */
export function getQrCodeP(params) {
    return new Promise(function (resolve, reject) {
        axios.get(GET_QR_CODE, {params}).then(response => {
            if (response.data) {
                if (response.data && response.data.data) {
                    resolve(response.data);
                } else {
                    resolve({});
                }
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 绑定优惠券
 * @public
 * @return {Promise}
 */
export function addCouponP(params) {
    return new Promise(function (resolve, reject) {
        axios.post(ADD_COUPON, params).then(response => {
            if (response.data) {
                resolve(response.data);
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 查询拼团动态
 * @public
 * @return {Promise}
 */
export function getGroupDynamicsP(params) {
    return new Promise(function (resolve, reject) {
        axios.get(GET_GROUP_DYNAMICS, { params }).then(response => {
            if (response.data) {
                resolve(response.data);
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 查询待拼团列表
 * @public
 * @return {Promise}
 */
export function getPendingGroupListP(params) {
    return new Promise(function (resolve, reject) {
        axios.get(GET_PENDING_GROUP_LIST, { params }).then(response => {
            if (response.data) {
                resolve(response.data);
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}
/** 
 * 获取订单信息
 * @public
 * @param object
 * @return {Promise}
 */
export function getOrderDetailP(params) {
    return getApiPromise(GET_ORDER_DETAIL_URL, params)
}
/** 
 * 区域限制校验
 * @public
 * @param object
 * @return {Promise}
 */
export function areaCheckP(params) {
    return new Promise(function (resolve, reject) {
        axios.post(AREA_CHECK_URL, params).then(response => {
            if (response.data) {
                resolve(response.data);
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}
/**
 * 查询客人关联的身份证列表
 * @public
 * @return {Promise}
 */
export function queryCustomerIdentityListP(params) {
    return new Promise(function (resolve, reject) {
        axios.get(QUERY_CUSTOMER_IDENTITY_LIST_URL, params).then(response => {
            if (response.data) {
                resolve(response.data);
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}
/**
 * 获取城市列表
 * @public
 * @return {Promise}
 */
export function getCityDataP(params) {
    return new Promise(function (resolve, reject) {
        axios.get(CITY_URL, { params }).then(response => {
            if (response.data) {
                resolve(response.data);
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 下单接口（兑换券接口）
 * @public
 * @return {Promise}
 */
export function exchangeP(params) {
    return new Promise(function (resolve, reject) {
        axios.post(EXCHANGE_URL, params).then(response => {
            resolve(response && response.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 查询行程4.0
 * @public
 * @return {Promise}
 */
export function getJourneyFourP(params) {
    return new Promise(function (resolve, reject) {
        axios.get(GET_JOURNEY_FOUR_URL, { params }).then(response => {
            if (response.data) {
                resolve(response.data);
            }
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}

/**
 * 预订校验接口
 * @public
 * @return {Promise}
 */
export function bookCheckP(params) {
    return new Promise(function (resolve, reject) {
        axios.post(BOOK_CHECK_URL, params).then(response => {
            resolve(response && response.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        });
    });
}
/**
 * cps接口
 * @public
 * @return {Promise}
 */
 export function cpsConfig(params){
    let environment = location.host
    let data = JSON.stringify(params)
    let ct = 30
    if(G.isWeApp){
        ct = 31
    }else if(G.isApp){
        ct = 10
    }
    let url = '//h5api.tuniu.com/channels/order/add?c={"ct":'+ct+'}'
    if(environment == 'm-p.tuniu.com'){
        url = '//h5api-p.tuniu.com/channels/order/add?c={"ct":'+ct+'}'
    }
    axios.defaults.headers.post["Content-Type"] = 'application/x-www-form-urlencoded'
    axios.defaults.withCredentials = true
    axios.post(url,data)
}


// WEBPACK FOOTER //
// libs/create-api-client.js